import styled from '@emotion/styled';
import { spacing, fontWeight, borderRadius } from 'presentations/views/styles';
import { white } from 'presentations/views/styles/color';
import { CustomerStoryListItem } from 'presentations/api/schema/contents';
import Link from 'presentations/views/components/atoms/Link';
import { customerStoryPath } from 'presentations/routes/path';

export interface Props {
  customer: CustomerStoryListItem;
}

export default function Component(props: Props) {
  return (
    <CustomerListItem color={props.customer.customerColor}>
      <StyledLink href={customerStoryPath(props.customer.slug)}>
        <CustomerListItemImage>
          {/* <CustomerListItemImageMask color={props.customer.customerColor} /> */}
          <CustomerImage image={props.customer.thumbnailImageUrl} />
        </CustomerListItemImage>
        <CustomerListItemInner>
          <CustomerListItemTitle>{props.customer.title}</CustomerListItemTitle>
          <CustomerListItemCompanyImageContainer>
            <CustomerListItemCompanyImage
              src={props.customer.companyImageUrl || undefined}
            />
          </CustomerListItemCompanyImageContainer>
          <CustomerListItemCompanyName>
            {props.customer.customerName}
          </CustomerListItemCompanyName>
        </CustomerListItemInner>
      </StyledLink>
    </CustomerListItem>
  );
}

const CustomerListItem = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  border-radius: ${borderRadius(16)};
  overflow: hidden;
`;
const StyledLink = styled(Link)`
  display: block;
`;
const CustomerListItemImage = styled.div`
  position: relative;
  height: 230px;
`;
// const CustomerListItemImageMask = styled.div<{ color: string }>`
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: ${(props) => props.color};
//   background: ${(props) =>
//     `linear-gradient(0deg, ${props.color} 0%, ${props.color}00 100%)`};
// `;
const CustomerListItemInner = styled.div`
  padding: ${spacing(24)};
  color: ${white};
  font-weight: ${fontWeight('bold')};
  letter-spacing: 0.02em;
  line-height: 1.6;
`;
const CustomerListItemCompanyImageContainer = styled.div`
  background-color: ${white};
  padding: ${spacing(8)};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${borderRadius(6)};
  margin-top: ${spacing(16)};
`;
const CustomerListItemCompanyImage = styled.img`
  width: auto;
  height: 24px;
`;
const CustomerListItemCompanyName = styled.div`
  margin-top: ${spacing(16)};
  text-align: center;
`;
const CustomerListItemTitle = styled.div`
  text-align: center;
`;

const CustomerImage = styled.div<{ image: string | null }>`
  background-image: url(${(props) => props.image});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  background-position: center;
`;
